import React from 'react'
import {Button,Container} from "semantic-ui-react";
import PropTypes from "prop-types";
import {Icon} from 'semantic-ui-react'

function OrderResult(props){

    OrderResult.propTypes = {
        prev: PropTypes.func,
        next: PropTypes.func,
        selectPaymentMethod: PropTypes.func,
        changeValidatedStatus: PropTypes.func,
        operationResult: PropTypes.object,
        closeModal: PropTypes.func
    };
    return (
        <React.Fragment>
            <Container textAlign='center'>
                {props.operationResult.resultCode == 1000 ? (<Icon inverted color='blue' name='check circle outline' size='massive'  /> ) :
                    (<Icon inverted color='red' name='close' size='massive'  />)
                }
                <br/>
                <br/>
                <p>{props.operationResult.resultDesc}</p>
                <br/>
                <Button onClick={props.closeModal}>Kapat</Button>
            </Container>
        </React.Fragment>
    )

}

export default OrderResult;